import React, { useEffect } from 'react';

import {
  PaymentTypes,
  Totals as TotalsType,
  DeliveryTypes,
} from '../../../models/checkout_model';
import { formatNumber } from '../../../middleware/common-functions';
import AtratoComp from './atratoComponent';
import {
  PayPalScriptProvider,
  PayPalButtons,
  usePayPalScriptReducer,
} from '@paypal/react-paypal-js';
import { CartProductItem } from '../../../models/cart_model';
import { UserDeliveryData, UserType } from '../../../models/user_model';
import { ZoneItem } from '../../../models/branch_model';
import { OrderType } from '../../../models/order_model';
import WalletBrick from './mpWallet';
import mp_logo from '../../../assets/MP_RGB_HANDSHAKE_color_horizontal.png';

type CartResumeProps = {
  totals: TotalsType;
  error_message: any;
  cart_id?: string;
  updateSection: any;
  next: any;
  disabled_btn: boolean | 'hidden';
  placeOrder: any;
  isDelivery: boolean;
  payment_type: PaymentTypes;
  products: CartProductItem[];
  deliveryData: UserDeliveryData;
  delivery_type: DeliveryTypes;
  selectedBranch: string | false;
  active_city: string | false;
  branches: ZoneItem[];
  user: UserType;
  setOrderObject: () => OrderType;
};

type PaypalSettingsType = {
  active: boolean;
  mode: 'sandbox' | 'production';
  sandbox_client_id: string;
  production_client_id: string;
};

type Paypal = {
  color?: 'gold' | 'blue' | 'silver' | 'white' | 'black';
  height?: number;
  label?:
    | 'paypal'
    | 'checkout'
    | 'buynow'
    | 'pay'
    | 'installment'
    | 'subscribe'
    | 'donate';
  layout?: 'vertical' | 'horizontal';
  shape?: 'rect' | 'pill';
  tagline?: boolean;
};

const CartResume: React.FC<CartResumeProps> = ({
  totals,
  error_message,
  updateSection,
  next,
  disabled_btn,
  placeOrder,
  cart_id,
  isDelivery,
  payment_type,
  products,
  deliveryData,
  delivery_type,
  selectedBranch,
  active_city,
  branches,
  user,
  setOrderObject,
}) => {
  const paypal: PaypalSettingsType = {
    active: true,
    mode: window.location.hostname === 'localhost' ? 'sandbox' : 'production',
    sandbox_client_id:
      'AWKtako7BTOmIZJK-WBrbUnxB3VvZgwHQ04Eq8wlssneJoda-pGqV36QSs8FhjqoewI-AeU0nKGAD-FZ',
    production_client_id:
      'AQZtrYmtA4-ULK4bOPO3kvg8I-DoQfiCsxYyKX8stKqwxkaQDm9y73JuhSJHPKrIGuOfBno1tZTQftQJ',
  };
  return (
    <div className={`cart_resume ${next ? 'xs_hidden' : ''}`}>
      <Totals totals={totals} />
      {error_message && (
        <div>
          <div className="alert alert-danger" id="alert-shake">
            <i className="fas fa-exclamation-circle mr-2"></i>
            {error_message}
          </div>
          <div>
            <p>
              ¿Realizas compras desde el extranjero? Contáctanos y te ayudaremos
              a gestionar tu pago de manera segura y eficiente.
            </p>
            <p>
              <strong>WhatsApp:</strong>{' '}
              <a
                href="https://web.whatsapp.com/send/?phone=526141911212&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
              >
                614-191-1212
              </a>
              <br />
              <strong>Email:</strong>{' '}
              <a href="mailto:servicio@mathasa.com.mx">
                servicio@mathasa.com.mx
              </a>
            </p>
          </div>
        </div>
      )}
      {isDelivery && (
        <div className="delivery-info">
          <div className="d-flex">
            <i className="fas fa-info-circle mt-1 pr-2" aria-hidden="true"></i>
            <span>
              El costo del flete puede variar según factores como el volumen,
              peso o distancia del envío.
              <br />
              Te notificaremos de cualquier ajuste antes de procesar tu pedido.
            </span>
          </div>
        </div>
      )}
      {payment_type === 'atrato' && !next ? (
        <div className="alert alert-info">
          <i className="fas fa-exclamation-circle mr-2"></i>
          <span>
            ¡Ya casi tendrás tu compra!, para obtener tu producto es necesario
            que completes el proceso de solicitud de crédito con Atrato. En el
            siguente paso serás redirigido a la solicitud de crédito de manera
            automática, <br />
            Tu orden será procesada cuando termines el proceso en Atrato
          </span>
        </div>
      ) : null}
      {payment_type === 'paypal' && !next ? (
        <PayPalScriptProvider
          options={{
            'client-id':
              paypal.mode === 'sandbox'
                ? paypal.sandbox_client_id
                : paypal.production_client_id,
            currency: 'MXN',
            components: 'buttons',
            'disable-funding': 'card',
          }}
        >
          <ButtonWrapper
            placeOrder={placeOrder}
            showSpinner={false}
            total={totals.total}
            products={products}
            deliveryData={deliveryData}
            delivery_type={delivery_type}
            selectedBranch={selectedBranch}
            active_city={active_city}
            branches={branches}
            totals={totals}
            user={user}
          />
        </PayPalScriptProvider>
      ) : null}
      {payment_type === 'mp_wallet' && !next ? (
        <div className="text-center mb-3">
          <img src={mp_logo} alt="Mercado Pago" style={{ maxWidth: '180px' }} />
        </div>
      ) : null}
      {payment_type === 'mp_wallet' && !next ? (
        <WalletBrick
          total={totals.total}
          user={user}
          products={products}
          deliveryData={deliveryData}
          shipping={totals.shipping || 0}
          cart_id={cart_id}
          setOrderObject={setOrderObject}
        />
      ) : null}
      <AtratoComp
        totals={totals}
        show={payment_type === 'atrato' && !next}
        orderId={cart_id}
      />
      {disabled_btn === 'hidden' || payment_type === 'online' ? null : (
        <button
          onClick={next ? updateSection : placeOrder}
          type="button"
          disabled={disabled_btn}
          data-next={next}
          id="section_continue-button"
          className={`btn btn-block btn-cart text-capitalize py-4 py-md-3 fixed ${
            payment_type === 'atrato' ||
            payment_type === 'paypal' ||
            payment_type === 'mp_wallet'
              ? 'd-none'
              : ''
          }`}
        >
          {next ? 'Continuar' : 'Confirmar Pedido'}
        </button>
      )}
    </div>
  );
};

const Totals: React.FC<{ totals: TotalsType }> = ({ totals }) => (
  <div className="totals ">
    <p>
      <span>Subtotal</span> <span>${formatNumber(totals.subtotal)}</span>
    </p>
    <p>
      <span>IVA</span> <span>${formatNumber(totals.tax)}</span>
    </p>
    <hr />
    {totals.discount ? (
      <p>
        <span>Descuentos</span>{' '}
        <span className="text-danger">-${formatNumber(totals.discount)}</span>
      </p>
    ) : null}
    <p>
      <span>Costo Envío</span> <span>${formatNumber(totals.shipping)}</span>
    </p>
    {totals.comission && totals.comission > 0 ? (
      <p>
        <span>Comisión Pago a Meses</span>{' '}
        <span>${formatNumber(totals.comission)}</span>
      </p>
    ) : null}
    <hr />
    <p>
      <span>Total</span>{' '}
      <span>
        $
        {totals.comission && totals.comission > 0
          ? formatNumber(totals.total + totals.comission)
          : formatNumber(totals.total)}
      </span>
    </p>
  </div>
);

export const CvvConfirm: React.FC<{
  cvv: string | undefined;
  handleCartData: any;
  getCVCProps: any;
}> = ({ cvv, handleCartData, getCVCProps }) => {
  return (
    <div className="form-group mb-3 ">
      <label htmlFor="inputPassword4">Confirma tu CVV</label>
      <input
        {...getCVCProps({
          onChange: handleCartData,
        })}
        data-type="cvv"
        type="text"
        className="form-control"
        value={cvv}
      />
    </div>
  );
};

type ButtonWrapperProps = {
  showSpinner: boolean;
  total: number;
  placeOrder: any;
  products: CartProductItem[];
  deliveryData: UserDeliveryData;
  delivery_type: DeliveryTypes;
  selectedBranch: string | false;
  active_city: string | false;
  branches: ZoneItem[];
  totals: TotalsType;
  user: UserType;
};
const ButtonWrapper: React.FC<ButtonWrapperProps> = ({
  showSpinner,
  total,
  placeOrder,
  products,
  deliveryData,
  delivery_type,
  selectedBranch,
  active_city,
  branches,
  totals,
}) => {
  const style: Paypal = { layout: 'vertical', label: 'paypal' };
  const [{ options, isPending }, dispatch] = usePayPalScriptReducer();
  console.log('cartResume.tsx:213 | total', total);

  useEffect(() => {
    dispatch({
      type: 'resetOptions',
      value: {
        ...options,
        currency: 'MXN',
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSpinner]);

  if (total <= 0) return null;

  return (
    <PayPalButtons
      style={style}
      disabled={false}
      forceReRender={[total, 'MXN', style]}
      fundingSource={undefined}
      createOrder={async (_, actions) => {
        const items = products.map((product) => ({
          name: product.title,
          quantity: product.cant.toString(),
          unit_amount: {
            currency_code: 'MXN',
            value: product.price.toLocaleString('fullwide', {
              useGrouping: false,
            }),
          },
        }));

        let shipping_address: any = undefined; // Initialize as undefined
        let shipping_preference:
          | 'NO_SHIPPING'
          | 'SET_PROVIDED_ADDRESS'
          | 'GET_FROM_FILE' = 'NO_SHIPPING';

        if (delivery_type === 'shipping') {
          shipping_preference = 'SET_PROVIDED_ADDRESS';
          shipping_address = {
            address_line_1: deliveryData.street + ' ' + deliveryData.numext,
            address_line_2: deliveryData.colonia,
            admin_area_2: deliveryData.city,
            admin_area_1: deliveryData.state,
            postal_code: deliveryData.zip,
            country_code: deliveryData.countrycode || 'MX',
          };
        }

        const purchase_unit_shipping = shipping_address
          ? {
              address: shipping_address,
              options: [
                {
                  id:
                    delivery_type === 'shipping'
                      ? 'shipping-method-1'
                      : 'pickup-method-1',
                  label:
                    delivery_type === 'shipping'
                      ? 'Standard Shipping'
                      : 'Store Pickup',
                  selected: true,
                  type: delivery_type === 'shipping' ? 'SHIPPING' : 'PICKUP',
                  amount: {
                    currency_code: 'MXN',
                    value:
                      totals.shipping?.toLocaleString('fullwide', {
                        useGrouping: false,
                      }) || '0.00',
                  },
                },
              ],
            }
          : undefined;

        const itemst_total = items.reduce((acc, item) => {
          return (
            acc + parseFloat(item.unit_amount.value) * parseInt(item.quantity)
          );
        }, 0);

        const purchase_units = [
          {
            amount: {
              currency_code: 'MXN',
              value: total.toLocaleString('fullwide', { useGrouping: false }),
              breakdown: {
                item_total: {
                  currency_code: 'MXN',
                  value: itemst_total.toLocaleString('fullwide', {
                    useGrouping: false,
                  }),
                },
              },
            },
            items: items,
            ...(purchase_unit_shipping && { shipping: purchase_unit_shipping }), // Conditionally include shipping
          },
        ];

        const orderId = await actions.order.create({
          purchase_units: purchase_units,
        });
        return orderId;
      }}
      onError={(err) => {
        console.log('payment.tsx:201 | err', err);
        if (typeof window.dataLayer != 'undefined') {
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'payment_attempt',
            event_category: 'Ecommerce',
            event_label: 'PayPal error',
            payment_method: 'paypal',
          });
        }
      }}
      onApprove={async (data, actions) => {
        try {
          const details = await actions!.order!.capture();
          console.log('payment.tsx:205 | actions', actions);
          console.log('payment.tsx:206 | details', details);
          try {
            // Pass PayPal payment data to placeOrder
            const capture = details.purchase_units[0]?.payments?.captures?.[0];
            const paypalData = {
              payment_id: capture?.id || details.id,
              payer_id: details.payer?.payer_id,
              status: details.status,
              email: details.payer?.email_address,
            };
            debugger;
            placeOrder(false, false, false, paypalData);
          } catch (error) {
            ////log error to sentry
            console.log('payment.tsx:232 | error', error);

            return;
          }
        } catch (error) {
          ////log error to sentry
          console.log('payment.tsx:241 | error', error);
          return;
        }
      }}
    />
  );
};

export default CartResume;
